import React from 'react'
import PropTypes from 'prop-types'

import Text from 'components/_new/typography/Text/Text'
import Field from 'components/_new/forms/Field/Field'

import messages from './messages'


const ExceptMobile = ({ field, inputId, loading, onSubmit }) => (
  <Field
    field={field}
    placeholder={messages.placeholder}
    id={inputId}
    standardView
    loading={loading}
    afterNode={(
      <Text
        message={messages.buttonTitle}
        size="12-24"
        color="gray-50"
        uppercase
        semibold
      />
    )}
    onAfterNodeClick={onSubmit}
  />
)


ExceptMobile.propTypes = {
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
}


export default ExceptMobile
